import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__